export class ReminderRequestModel{
    public createdForUser:number;
    public crmUserId:number;
    public description:string;
    public dueDateTime:string;
    public reminderType:string;
    public sessionToken:string;
    public title:string;
    public workItemId:number;
}